import * as React from "react";
import PropTypes from "prop-types";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function PaginationControlled({ page, setPage, totalPage }) {
  const isMobile = useMediaQuery("(max-width:767px)");
  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <Stack spacing={2}>
      <Pagination
        count={totalPage}
        page={page}
        onChange={handleChange}
        color="secondary"
        size={isMobile ? "small" : "medium"}
        siblingCount={isMobile ? 0 : 1}
      />
    </Stack>
  );
}
PaginationControlled.propTypes = {
  totalPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
};
